module.exports = {
	"articleTitle1": "Housing considering closing Betsy Barbour's dining hall",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Betsy Barbour House",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/decoding-martha-myth",
	"articleSnippet1": "Feb 4, 2010 ... To the chagrin of many students living in Betsy Barbour, the residence hall's \ndining hall may be closed come next year. According to University ...",
	"articleSnippet2": "Apr 11, 2001 ... Like other female residences such as Betsy Barbour and Helen ... wanted the \nbuilding to feel like an English country house, and some of that ...",
	"totalMisc": 0,
	"articleTitle2": "Decoding the Martha myth",
	"address": "420 S State St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.277294,
		"lng": -83.741565
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/betsybarbour.json
// module id = 827
// module chunks = 0